/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MSP14InputContentDTO { 
    sno?: string | null;
    fullName?: string | null;
    formerName?: string | null;
    designation?: string | null;
    dob?: string | null;
    qualification?: string | null;
    yearObtained?: string | null;
    dateofAppointment?: string | null;
    previousEmployment?: string | null;
}

